"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function applicationDataExists() {
    // Check also for undefined so Test-Runners doesn't crash
    return typeof window !== "undefined" && window.ELSTR && window.ELSTR.applicationData;
}
exports.applicationDataExists = applicationDataExists;
function configExists() {
    return applicationDataExists() && window.ELSTR.applicationData.config;
}
exports.configExists = configExists;
function languageExists() {
    return applicationDataExists() && window.ELSTR.applicationData.language;
}
exports.languageExists = languageExists;
function userExists() {
    return applicationDataExists() && window.ELSTR.applicationData.user;
}
exports.userExists = userExists;
//# sourceMappingURL=ElstrApplicationData.js.map